import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { FundPerformanceAnnualizedComponent } from './fund-performance-annualized/fund-performance-annualized.component';
import { FundPerformanceEntryComponent } from './fund-performance-entry/fund-performance-entry.component';
import { FundPerformanceAnnualizedTableComponent } from './fund-performance-annualized/fund-performance-annualized-table/fund-performance-annualized-table.component';
import { FundPerformanceCumulativeComponent } from './fund-performance-cumulative/fund-performance-cumulative.component';
import { FundPerformanceCumulativeGraphComponent } from './fund-performance-cumulative/fund-performance-cumulative-graph/fund-performance-cumulative-graph.component';
import { FundPerformanceCumulativeTableComponent } from './fund-performance-cumulative/fund-performance-cumulative-table/fund-performance-cumulative-table.component';
import { RiskMeasuresComponent } from './risk-measures/risk-measures.component';
import { RiskMeasuresService } from './services/risk-measures.service';
import { FundPerformanceAnnualizedService } from './services/fund-performance-annualized.service';
import { FundPerformanceDiscreteReturnsComponent } from './fund-performance-discrete-returns/fund-performance-discrete-returns.component';
import { FundPerformanceCalendarYearService } from './services/fund-performance-calendar-year.service';
import { FundPerformanceCalendarYearTableComponent } from './fund-performance-calendar-year/fund-performance-calendar-year-table/fund-performance-calendar-year-table.component';
import { FundPerformanceDiscreteReturnsTableComponent } from './fund-performance-discrete-returns/fund-performance-discrete-returns-table/fund-performance-discrete-returns-table.component';
import { FundPerformanceDiscreteReturnsService } from './services/fund-performance-discrete-returns.service';
import { FundPerformanceCumulativeService } from './services/fund-performance-cumulative.service';
import { FundPerformanceCalendarYearComponent } from './fund-performance-calendar-year/fund-performance-calendar-year.component';
import { FundPerformanceColumnChartComponent } from './fund-performance-column-chart/fund-performance-column-chart.component';
import { RiskReturnProfileComponent } from './risk-return-profile/risk-return-profile.component';
import { EfficiencyAnalysisComponent } from './risk-measures/efficiency-analysis/efficiency-analysis.component';

import { FundPerformanceMonthlyTotalReturnsComponent } from './fund-performance-monthly-total-returns/fund-performance-monthly-total-returns.component';
import { FundPerformanceMonthlyTotalReturnsChartComponent } from './fund-performance-monthly-total-returns/fund-performance-monthly-total-returns-chart/fund-performance-monthly-total-returns-chart.component';
import { FundPerformanceMonthlyTotalReturnsTableComponent } from './fund-performance-monthly-total-returns/fund-performance-monthly-total-returns-table/fund-performance-monthly-total-returns-table.component';
import { MonthPickerModule } from '@frk/eds-components';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule,
    MonthPickerModule,
  ],
  declarations: [
    FundPerformanceEntryComponent,
    FundPerformanceAnnualizedComponent,
    FundPerformanceAnnualizedTableComponent,
    FundPerformanceCumulativeComponent,
    FundPerformanceCumulativeTableComponent,
    FundPerformanceCumulativeGraphComponent,
    FundPerformanceDiscreteReturnsComponent,
    FundPerformanceDiscreteReturnsTableComponent,
    FundPerformanceCalendarYearComponent,
    FundPerformanceCalendarYearTableComponent,
    RiskMeasuresComponent,
    FundPerformanceColumnChartComponent,
    RiskReturnProfileComponent,
    EfficiencyAnalysisComponent,
    FundPerformanceMonthlyTotalReturnsComponent,
    FundPerformanceMonthlyTotalReturnsChartComponent,
    FundPerformanceMonthlyTotalReturnsTableComponent,
  ],
  // providers: [
  //   FundPerformanceAnnualizedService,
  //   FundPerformanceCumulativeService,
  //   FundPerformanceDiscreteReturnsService,
  //   FundPerformanceCalendarYearService,
  //   RiskMeasuresService,
  // ],
})
export class FundPerformanceModule {}

export const fundPerformanceModuleComponentMapping = {
  'Fund Performance': FundPerformanceEntryComponent,
};
